export default {
  namespaced: true,
  state: {
    filtrarPorSede: false,
  },
  mutations: {
    setFiltrarPorSede(state, value) {
      state.filtrarPorSede = value;
    },
  },
  actions: {
    setFiltrarPorSede({ commit }, value) {
      commit('setFiltrarPorSede', value);
    },
  },
  getters: {
    getFiltrarPorSede: (state) => state.filtrarPorSede,
    permisosAcademicosSede(state, getters, rootState) {
      return (
        getters.permisosAcademicosSedeDBS ||
        rootState.DATA_USER.id == 1331 || // CARMEN JULIA VICTORIA MENDOZA- CAMARGO ADMIN - CAMARGO
        rootState.DATA_USER.id == 9394 || // JOSE ALEJANDRO CRUZ RIVA -	COORDINADOR ACADÉMICO - COCHABAMBA 1
        rootState.DATA_USER.id == 9845 || // ALEJANDRA LILI RODRIGUEZ FLORES	- COORDINADOR ACADÉMICO - COCHABAMBA 2
        rootState.DATA_USER.id == 62097 || // SHIRLEY TATIANA COLQUE CUELLAR	- AUXILIAR ACADÉMICO - LA PAZ 1
        rootState.DATA_USER.id == 77191 || // GRISSEL ADRIANA SUXO LEANDRO	- AUXILIAR ACADÉMICO - LA PAZ 2
        rootState.DATA_USER.id == 25406 || // LAURA PATRICIA SOLIZ MICHEL	- AUXILIAR ACADÉMICO - POTOSI
        rootState.DATA_USER.id == 56061 || // JOSE DANIEL GARCIA LUJAN	- AUXILIAR ACADÉMICO - SANTA CRUZ 2
        rootState.DATA_USER.id == 14412 || // LUIS SANTOS MARTINEZ FLORES	- AUXILIAR ACADÉMICO - SUCRE 1
        rootState.DATA_USER.id == 53130 || // CARLA BEATRIZ TIRADO PADILLA	- AUXILIAR ACADÉMICO - SUCRE 2
        rootState.DATA_USER.id == 51124 || // JOANNA STHEFANY EGUEZ DAVILA	- AUXILIAR ACADÉMICO - TARIJA 1
        rootState.DATA_USER.id == 42 || // MARIELA LUCY ARMELLA RODRIGUEZ	- AUXILIAR ACADÉMICO - TARIJA 3
        rootState.DATA_USER.id == 2123 || // ANDREINA ELENA PEÑARANDA ORDOÑEZ	- AUXILIAR ACADÉMICO - YACUIBA
        rootState.DATA_USER.id == 12988 || // PAULA MARÍA DE LOS ANGELES MUÑOZ - COORDINADOR ACADÉMICO - ESAM LATAM
        rootState.DATA_USER.id == 72 || // ROCELIN YISEL JURADO CHURATA - GERENTE REGIONAL - ESAM LATAM
        rootState.DATA_USER.id == 70652 || // NELSON ANDRES NEGRETE MIRANDA - AUXILIAR ACADÉMICO - ESAM LATAM 2
        rootState.DATA_USER.id == 70413 || // JEANETH POMA MAMANI - COORDINADOR ACADÉMICO - ESAM ORURO
        rootState.DATA_USER.id == 116152 || // MARIANA EVELIN RIOS ORDOÑEZ - COORDINADOR ACADÉMICO - TARIJA 2
        rootState.DATA_USER.id == 127975 || // MIRANDA BARDALES VALERIA - AUXILIAR ACADÉMICO - ESAM LA PAZ
        rootState.DATA_USER.id == 62097 || // SHIRLEY TATIANA COLQUE CUELLAR - AUXILIAR ACADÉMICO - ESAM EL ALTO
        rootState.DATA_USER.id == 59487 || // AMERICO ITAMAR ECHALAR GUZMAN - PLANIFICADOR NACIONAL
        rootState.DATA_USER.id == 26471 || // JUSTINA ESTRADA PACARA - AUXILIAR ACADÉMICO - ESAM MONTEAGUDO
        rootState.DATA_USER.id == 84075 || // VALERIA ARACELLI SILVA COLQUE - COORDINADOR ACADÉMICO - ESAM TARIJA 1 - ESAM TARIJA 3 - ESAM TARIJA 4
        rootState.DATA_USER.id == 66725 || // OSCAR MAURICIO RIOS RODRIGUEZ - COORDINADOR ACADÉMICO - ESAM TARIJA 1 - ISPI TARIJA 1
        rootState.DATA_USER.id == 62096 || // MARIELA NICOL CARRASCO RIVEROS - COORDINADOR ACADÉMICO - ESAM LA PAZ SUCURSAL
        rootState.DATA_USER.id == 159011 || // GABRIELA MIRANDA ROBLES - AUXILIAR ACADÉMICO - ESAM SANTA CRUZ 2
        rootState.DATA_USER.id == 96279 || // ROCIO FLORA MAMANI CHAMBI - AUXILIAR ACADÉMICO - ESAM ORURO
        rootState.DATA_USER.id == 152838 || // CAMILA VALENTINA AYALA COROSTIAGA - AUXILIAR ACADÉMICO - ESAM LA PAZ 1 - ESAM LA PAZ 2
        rootState.DATA_USER.id == 154651 || // IRINA ROCHA SARAVIA - COORDINADOR ACADÉMICO - ESAM LATAM 2
        rootState.DATA_USER.id == 154092 || //  CAERO RAMOS GABRIELA - AUXILIAR ACADÉMICO - ESAM SANTA CRUZ 1
        rootState.CARGO.id == 3 || // GERENTE REGIONAL
        rootState.CARGO.id == 5 || // DIRECTOR ACADÉMICO
        rootState.CARGO.id == 6 || // COORDINADOR ACADÉMICO
        rootState.CARGO.id == 7 || // AUXILIAR ACADÉMICO
        rootState.CARGO.id == 1 // MASTER
      );
    },
    permisosAcademicosSedeDBS(state, getters, rootState) {
      return (
        rootState.DATA_USER.id == 52684 || // NOELIA VILLARPANDO NORMERES - COORDINADOR ACADÉMICO - DIGITAL SCHOOL SUCRE
        rootState.DATA_USER.id == 18622 || // SHAUNY QUEZADA CASTELLON - COORDINADOR ACADÉMICO - DIGITAL SCHOOL COCHABAMBA
        rootState.DATA_USER.id == 17765 || // VILMA PAULINA ARENAS ORDOÑEZ - COORDINADOR ACADÉMICO - DIGITAL SCHOOL COBIJA
        rootState.DATA_USER.id == 62081 || // INGRID PAMELA VILLARROEL - COORDINADOR ACADÉMICO - DIGITAL SCHOOL MONTEAGUDO
        rootState.DATA_USER.id == 81156 || // ALEXANDRA PAOLA VILLCA BARBEITO - COORDINADOR ACADÉMICO - DIGITAL SCHOOL TARIJA
        rootState.DATA_USER.id == 25404 || // VERONICA LOZA ROSALES - COORDINADOR ACADÉMICO - DIGITAL SCHOOL POTOSI
        rootState.DATA_USER.id == 30820 || // FANY ORTIZ VELASQUEZ - COORDINADOR ACADÉMICO - SUCRE 2 - MONTEAGUDO - DIGITAL SCHOOL MONTEAGUDO
        rootState.DATA_USER.id == 116061 || // JUAN GUSTAVO QUINTANA CUTIPA - COORDINADOR ACADÉMICO - SUCRE 2 - MONTEAGUDO - DIGITAL SCHOOL MONTEAGUDO
        rootState.DATA_USER.id == 1339 || // MARIA EUGENIA CHOQUE LLANOS - COORDINADOR ACADÉMICO - DIGITAL SCHOOL POTOSI
        rootState.DATA_USER.id == 12065 || // ARAMAYO MARTINEZ ANDREA LUCIA - COORDINADOR ACADÉMICO - DIGITAL SCHOOL MONTEAGUDO
        rootState.DATA_USER.id == 7983 || // Espinoza Colque Flabia Roxana - COORDINADOR ACADÉMICO - DIGITAL SCHOOL TARIJA
        rootState.DATA_USER.id == 1331 || // CARMEN JULIA VICTORIA MENDOZA- CAMARGO ADMIN - CAMARGO
        rootState.CARGO.id == 1 // MASTER
      );
    },
    permisosAcademicosSedeSoloLectura(state, getters, rootState) {
      return (
        rootState.DATA_USER.id == 62096 || // MARIELA NICOL CARRASCO RIVEROS - COORDINADOR ACADÉMICO - ESAM LA PAZ SUCURSAL
        rootState.DATA_USER.id == 18622 || // SHAUNY QUEZADA CASTELLON - COORDINADOR ACADÉMICO - ESAM LATAM 2
        rootState.DATA_USER.id == 6003 // ROXANA GABRIELA COLQUE TOLABA - COORDINADOR ACADÉMICO - ESAM TARIJA 2
      );
    },
    permisosAcademicosNacional(state, getters, rootState) {
      return (
        rootState.DATA_USER.id == 19467 || // JUAN ÁNGEL LÓPEZ TAPIA - ENC SISTEMAS INFORMÁTICOS
        rootState.DATA_USER.id == 35886 || // CARLA ARACELY CRUZ CASTILLO - COORDINADOR ACADÉMICO
        rootState.DATA_USER.id == 59716 || // VALERIA VACA PRADO - REEMPLAZO DE CARLA CRUZ :(
        rootState.DATA_USER.id == 93 || // AMELIA GUZMAN - COORDINADOR ACADÉMICO
        rootState.DATA_USER.id == 47129 || // ELIO DIEGO CASTILLO ROSPILLOZA - ASESOR EJECUTIVO DE MARKETING
        rootState.DATA_USER.id == 22161 || // CINTIA BEATRIZ OROPEZA CHOQUELLAMPA - COORDINADOR ACADÉMICO
        rootState.DATA_USER.id == 59716 || // VALERIA DEL ROSARIO VACA PRADO - ASESOR EJECUTIVO DE MARKETING
        rootState.DATA_USER.id == 10859 || // LUCIA GUADALUPE ZEBALLOS VALDEZ - COORDINADOR ACADÉMICO - DIGITAL SCHOOL
        rootState.DATA_USER.id == 73 || // MARCIA ANDREA VARGAS LOPEZ - DIRECTOR ACADÉMICO - DIGITAL SCHOOL
        rootState.DATA_USER.id == 864 || // LUIS ALBERTO SAGREDO MAMANI - DIRECTOR ACADÉMICO - DIGITAL SCHOOL
        rootState.DATA_USER.id == 20 || // YENNY RAYMUNDA TORREZ ARGOTA - COORDINADOR ACADÉMICO - DIGITAL SCHOOL
        rootState.DATA_USER.id == 59487 || // AMERICO ITAMAR ECHALAR GUZMAN - PLANIFICADOR NACIONAL
        rootState.DATA_USER.id == 9029 || // DINKA RAHIZA GARDILCIC FLORES - Gerente Regional
        rootState.DATA_USER.id == 15857 || // JHASMANY WALTER AYLLON ORELLANA - Ejecutivo Gestión Empresarial
        rootState.DATA_USER.id == 39155 || // GUSTAVO DENIS TORRICO CHAMOSO - Ejecutivo Gestión Empresarial
        rootState.DATA_USER.id == 94366 || // CAMILA NATALIA BALDERRAMA BAPTISTA - Ejecutivo Gestión Empresarial
        rootState.DATA_USER.id == 156601 || // ADRIANA ARACELY LUCAS - COORDINADOR ACADÉMICO
        rootState.DATA_USER.id == 163204 || // ISRAEL ABEL MARCANI AGUILAR - CONSULTOR EXTERNO
        rootState.CARGO.id == 1 // MASTER
      );
    },
    permisosGestionEmpresarial(state, getters, rootState) {
      return (
        rootState.DATA_USER.id == 59487 || // AMERICO ITAMAR ECHALAR GUZMAN - PLANIFICADOR NACIONAL
        rootState.CARGO.id == 26 // EJECUTIVO GESTIÓN EMPRESARIAL
      );
    },
    permisosContabilidadNacional(state, getters, rootState) {
      return (
        rootState.DATA_USER.id == 18 // GLODY RAQUEL ESPINOZA COLQUE - AUXILIAR CONTABLE
      );
    },
  },
};
